import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const sectionTitleStyle = {
  fontWeight: 700,
  color: "#334155",
  fontSize: "15px",
  marginBottom: "10px",
};

const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const accentColor = "#06d1c6";

// Indian number format (e.g. 13,46,835)
function formatINR(num) {
  const s = String(Math.round(num));
  const len = s.length;
  if (len <= 3) return s;
  let result = s.slice(-3);
  for (let i = len - 3; i > 0; i -= 2) {
    const start = Math.max(0, i - 2);
    result = s.slice(start, i) + "," + result;
  }
  return result;
}

const SAMPLE_DATA = [
  {
    investor: "PRAVEEN GHANSHYAM TOSHNIWAL",
    purchaseValue: 150000,
    currentValue: 210184,
    oneDayChange: -407,
    dividend: 0,
    averageDays: 187,
    gain: 60184,
    absoluteReturn: 40.12,
    cagr: 78.51,
  },
  {
    investor: "VISHVESH VIVEK JAIN",
    purchaseValue: 196765,
    currentValue: 200625,
    oneDayChange: -953,
    dividend: 0,
    averageDays: 127,
    gain: 3859,
    absoluteReturn: 1.96,
    cagr: 5.62,
  },
  {
    investor: "RAKSHADEVI CHANDRAPRAKASH AGARWAL",
    purchaseValue: 180000,
    currentValue: 186360,
    oneDayChange: -1321,
    dividend: 0,
    averageDays: 163,
    gain: 6360,
    absoluteReturn: 3.53,
    cagr: 7.93,
  },
];

const TOTALS = {
  purchaseValue: 1346835,
  currentValue: 1453697,
  oneDayChange: -8091,
  dividend: 942,
  averageDays: 158,
  gain: 107804,
  absoluteReturn: 8.0,
  cagr: 18.46,
};

export default function InvestorDataMining() {
  const [assetsClass, setAssetsClass] = useState("mutual-fund");
  const [reportType, setReportType] = useState("portfolio-valuation");
  const [groupBy, setGroupBy] = useState("client");
  const [holdingDaysOp, setHoldingDaysOp] = useState(">");
  const [holdingDaysVal, setHoldingDaysVal] = useState("66");
  const [arn, setArn] = useState("all");
  const [changeOfBrokerAum, setChangeOfBrokerAum] = useState("include");
  const [sipAum, setSipAum] = useState("include");
  const [fund, setFund] = useState("all-selected");
  const [category, setCategory] = useState("all-selected");
  const [subCategory, setSubCategory] = useState("all-selected");
  const [viewType, setViewType] = useState("on-screen");
  const [sortBy, setSortBy] = useState("currentValue");
  const [sortDir, setSortDir] = useState("desc");

  const handleApply = () => {
    // TODO: fetch data from API
  };

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("desc");
    }
  };

  const SortIcon = ({ columnKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 ms-1 border-0"
      style={{ color: sortBy === columnKey ? accentColor : "#94a3b8", fontSize: "12px" }}
      onClick={() => toggleSort(columnKey)}
      aria-label={`Sort by ${columnKey}`}
    >
      <i className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`} style={{ opacity: sortBy === columnKey ? 1 : 0.4 }} />
    </button>
  );

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Investor Data Mining</h5>
            </div>
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/portfolio/comprehensive">Portfolio Management</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Investor Data Mining
                </li>
              </ol>
            </nav>
          </div>

          {/* Filter Section */}
          <div style={cardStyle}>
            <div className="row g-3">
              {/* Assets Class */}
              <div className="col-12 col-md-6 col-lg-4">
                <div style={sectionTitleStyle}>Assets Class:</div>
                <div className="d-flex gap-4">
                  {[
                    { value: "mutual-fund", label: "Mutual Fund" },
                    { value: "share-bond", label: "Share & Bond" },
                  ].map(({ value, label }) => (
                    <label key={value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input
                        type="radio"
                        name="assetsClass"
                        checked={assetsClass === value}
                        onChange={() => setAssetsClass(value)}
                        style={{ accentColor }}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Report Type */}
              <div className="col-12 col-md-6 col-lg-4">
                <div style={sectionTitleStyle}>Report Type:</div>
                <div className="d-flex flex-wrap gap-3">
                  {[
                    { value: "portfolio-valuation", label: "Portfolio Valuation" },
                    { value: "capital-gain-unrealized", label: "Capital Gain Unrealized" },
                    { value: "client-daily-aum", label: "Client Daily AUM" },
                  ].map(({ value, label }) => (
                    <label key={value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input
                        type="radio"
                        name="reportType"
                        checked={reportType === value}
                        onChange={() => setReportType(value)}
                        style={{ accentColor }}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Group By */}
              <div className="col-12 col-md-6 col-lg-4">
                <div style={sectionTitleStyle}>Group By:</div>
                <div className="d-flex gap-3">
                  {[
                    { value: "client", label: "Client" },
                    { value: "family-head", label: "Family Head" },
                    { value: "folio", label: "Folio" },
                  ].map(({ value, label }) => (
                    <label key={value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input
                        type="radio"
                        name="groupBy"
                        checked={groupBy === value}
                        onChange={() => setGroupBy(value)}
                        style={{ accentColor }}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Filters Row 1 */}
              <div className="col-12">
                <div style={sectionTitleStyle}>Filters:</div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">Holding Days</label>
                <div className="d-flex gap-1">
                  <select
                    value={holdingDaysOp}
                    onChange={(e) => setHoldingDaysOp(e.target.value)}
                    style={{ ...inputStyle, width: "60px" }}
                  >
                    <option value=">">&gt;</option>
                    <option value=">=">&#8805;</option>
                    <option value="=">=</option>
                    <option value="<">&lt;</option>
                    <option value="<=">&#8804;</option>
                  </select>
                  <input
                    type="text"
                    value={holdingDaysVal}
                    onChange={(e) => setHoldingDaysVal(e.target.value)}
                    style={{ ...inputStyle, flex: 1 }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">ARN</label>
                <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle}>
                  <option value="all">All</option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">Change of Broker AUM</label>
                <select value={changeOfBrokerAum} onChange={(e) => setChangeOfBrokerAum(e.target.value)} style={inputStyle}>
                  <option value="include">Include</option>
                  <option value="exclude">Exclude</option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">SIP AUM</label>
                <select value={sipAum} onChange={(e) => setSipAum(e.target.value)} style={inputStyle}>
                  <option value="include">Include</option>
                  <option value="exclude">Exclude</option>
                </select>
              </div>

              {/* Filters Row 2 */}
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">Select User</label>
                <button
                  type="button"
                  className="btn d-flex align-items-center gap-2 w-100"
                  style={{ background: accentColor, color: "#fff", border: "none", fontWeight: 600 }}
                >
                  <i className="fa fa-user" />
                  Select User
                  <i className="fa fa-chevron-down ms-auto" style={{ fontSize: "12px" }} />
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">Fund</label>
                <select value={fund} onChange={(e) => setFund(e.target.value)} style={inputStyle}>
                  <option value="all-selected">All Selected</option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">Category</label>
                <select value={category} onChange={(e) => setCategory(e.target.value)} style={inputStyle}>
                  <option value="all-selected">All Selected</option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <label className="form-label small text-secondary">Sub Category</label>
                <select value={subCategory} onChange={(e) => setSubCategory(e.target.value)} style={inputStyle}>
                  <option value="all-selected">All Selected</option>
                </select>
              </div>

              {/* View Type */}
              <div className="col-12">
                <div style={sectionTitleStyle}>View Type:</div>
                <div className="d-flex gap-3">
                  {[
                    { value: "on-screen", label: "On Screen" },
                    { value: "xls", label: "XLS" },
                  ].map(({ value, label }) => (
                    <label key={value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input
                        type="radio"
                        name="viewType"
                        checked={viewType === value}
                        onChange={() => setViewType(value)}
                        style={{ accentColor }}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="text-center mt-4">
              <button
                type="button"
                onClick={handleApply}
                style={{
                  background: accentColor,
                  color: "#fff",
                  border: "none",
                  padding: "10px 40px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "15px",
                  cursor: "pointer",
                }}
              >
                Apply
              </button>
            </div>
          </div>

          {/* Data Table */}
          <div style={{ ...cardStyle, overflowX: "auto" }}>
            <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc" }}>
                  <th className="text-nowrap">
                    Investor
                    <SortIcon columnKey="investor" />
                  </th>
                  <th className="text-nowrap text-end">
                    Purchase Value
                    <SortIcon columnKey="purchaseValue" />
                  </th>
                  <th className="text-nowrap text-end" style={{ color: accentColor }}>
                    Current Value
                    <SortIcon columnKey="currentValue" />
                  </th>
                  <th className="text-nowrap text-end">
                    One Day Change
                    <SortIcon columnKey="oneDayChange" />
                  </th>
                  <th className="text-nowrap text-end">
                    Dividend
                    <SortIcon columnKey="dividend" />
                  </th>
                  <th className="text-nowrap text-end">
                    Average Days
                    <SortIcon columnKey="averageDays" />
                  </th>
                  <th className="text-nowrap text-end">
                    Gain
                    <SortIcon columnKey="gain" />
                  </th>
                  <th className="text-nowrap text-end">
                    Absolute Return
                    <SortIcon columnKey="absoluteReturn" />
                  </th>
                  <th className="text-nowrap text-end">
                    CAGR
                    <SortIcon columnKey="cagr" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Total row */}
                <tr style={{ backgroundColor: "rgba(6, 209, 198, 0.12)", fontWeight: 600 }}>
                  <td>Total</td>
                  <td className="text-end">{formatINR(TOTALS.purchaseValue)}</td>
                  <td className="text-end">{formatINR(TOTALS.currentValue)}</td>
                  <td className="text-end" style={{ color: TOTALS.oneDayChange < 0 ? "#dc2626" : "inherit" }}>
                    {TOTALS.oneDayChange < 0 ? "-" : ""}{formatINR(Math.abs(TOTALS.oneDayChange))}
                  </td>
                  <td className="text-end">{formatINR(TOTALS.dividend)}</td>
                  <td className="text-end">{TOTALS.averageDays}</td>
                  <td className="text-end">{formatINR(TOTALS.gain)}</td>
                  <td className="text-end">{TOTALS.absoluteReturn}</td>
                  <td className="text-end">{TOTALS.cagr}</td>
                </tr>
                {SAMPLE_DATA.map((row, idx) => (
                  <tr key={idx}>
                    <td className="text-nowrap">{row.investor}</td>
                    <td className="text-end">{formatINR(row.purchaseValue)}</td>
                    <td className="text-end">{formatINR(row.currentValue)}</td>
                    <td
                      className="text-end"
                      style={{ color: row.oneDayChange < 0 ? "#dc2626" : "inherit" }}
                    >
                      {row.oneDayChange < 0 ? "-" : ""}{formatINR(Math.abs(row.oneDayChange))}
                    </td>
                    <td className="text-end">{formatINR(row.dividend)}</td>
                    <td className="text-end">{row.averageDays}</td>
                    <td className="text-end">{formatINR(row.gain)}</td>
                    <td className="text-end">{row.absoluteReturn}</td>
                    <td className="text-end">{row.cagr}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
